import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { MONTHS, STATE } from "@/components/previsionale/helpers";

const m = (v) => `${Number(v || 0).toLocaleString("it-IT", { minimumFractionDigits: 0, maximumFractionDigits: 0 })} €`;
const p = (v) => `${Number(v || 0).toLocaleString("it-IT", { maximumFractionDigits: 1 })}%`;
const SEASON_PDF = { alta: "Alta", media: "Media", bassa: "Bassa" };

export async function exportPrevisionalePDF(d, chartsEl) {
  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
  const W = 297, M = 10;
  doc.setFont("helvetica", "bold"); doc.setFontSize(15); doc.setTextColor(15, 23, 42);
  doc.text(`Previsionale ${d.year}`, M, 14);
  doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor(100, 116, 139);
  doc.text(`Generato il ${d.today.split("-").reverse().join("/")} · Blu Lodge Maldives · importi in €`, M, 19);
  const t = d.totals, k = d.kpi, has = d.target.amount != null;
  const kp = [["Lordo confermato", m(t.entrate_conf)], ["Lordo previsto", m(t.entrate_prev)], ["Spese + imprevisti", m(t.spese_prev + t.impr_prev)],
    ["Netto previsto", m(t.netto_prev)], ["Netto da inizio anno", m(k.ytd_netto)], ["Obiettivo", has ? m(d.target.amount) : "—"],
    ["Scostamento", has ? `${m(k.scostamento)} (${p(k.scostamento_pct)})` : "—"], ["Lordo necessario", has ? m(k.required_gross) : "—"],
    ["Netto prudente", m(t.netto_prud)], ["Netto ottimistico", m(t.netto_ott)]];
  doc.setFontSize(8);
  kp.forEach(([l, v], i) => {
    const x = M + (i % 5) * 56, y = 27 + Math.floor(i / 5) * 10;
    doc.setTextColor(100, 116, 139); doc.text(l.toUpperCase(), x, y);
    doc.setTextColor(15, 23, 42); doc.setFont("helvetica", "bold"); doc.text(v, x, y + 4.5); doc.setFont("helvetica", "normal");
  });
  if (chartsEl) {
    const canvas = await html2canvas(chartsEl, { scale: 1.5, backgroundColor: "#ffffff", logging: false });
    const ih = Math.min(((W - 2 * M) * canvas.height) / canvas.width, 155);
    const iw = (ih * canvas.width) / canvas.height;
    doc.addImage(canvas.toDataURL("image/jpeg", 0.85), "JPEG", M, 46, iw, ih);
  }
  doc.addPage();
  const cols = ["Mese", "Stato", "Stag.", "Notti", "Occ.", "ADR", "Lordo", "Commiss.", "Tasse", "Fissi", "Variabili", "Vaagali", "Imprev.", "Netto", "Obiettivo", "Scost."];
  const wd = [12, 18, 11, 14, 13, 16, 21, 18, 17, 19, 19, 18, 17, 21, 20, 20];
  let y = 14;
  doc.setFont("helvetica", "bold"); doc.setFontSize(12); doc.text(`Tabella mensile ${d.year}`, M, y); y += 7;
  doc.setFontSize(8);
  const line = (vals, bold) => {
    let x = M;
    doc.setFont("helvetica", bold ? "bold" : "normal");
    vals.forEach((v, i) => { doc.text(String(v), i < 3 ? x : x + wd[i] - 1, y, { align: i < 3 ? "left" : "right" }); x += wd[i]; });
    y += 6;
  };
  doc.setTextColor(100, 116, 139); line(cols, true); doc.setTextColor(15, 23, 42);
  d.rows.forEach((r, i) => line([MONTHS[i], STATE[r.state][0], (SEASON_PDF[r.season] || "Bassa"), Math.round(r.nights_prev), p(r.occ_prev), m(r.adr),
    m(r.entrate_prev), m(r.commissioni), m(r.tasse), m(r.fissi), m(r.variabili_prev), m(r.vaagali), m(r.impr_prev), m(r.netto_prev),
    has ? m(r.target_month) : "—", has ? m(r.scostamento) : "—"]));
  line(["Totale", "", "", Math.round(t.nights_prev), "", "", m(t.entrate_prev), m(t.commissioni), m(t.tasse), m(t.fissi), m(t.variabili_prev), m(t.vaagali), m(t.impr_prev),
    m(t.netto_prev), has ? m(d.target.amount) : "—", has ? m(t.netto_prev - d.target.amount) : "—"], true);
  const v = d.v2 || {}, tx = v.taxes || {};
  const ascii = (s) => String(s).replace(/€/g, "EUR").replace(/[^\x20-\x7E\u00C0-\u00FF]/g, "");
  y += 4; doc.setFont("helvetica", "bold"); doc.setFontSize(10); doc.text(`Ipotesi usate (scenario ${v.scenario})`, M, y); y += 5;
  doc.setFont("helvetica", "normal"); doc.setFontSize(8);
  [`Cancellazioni ${p(v.cancel_rate)} (${v.cancel_source}) - commissioni ${p(v.comm_rate)} del lordo - ospiti medi ${v.avg_guests}`,
    `TGST ${p(tx.tgst_pct)} sul ${p(tx.tax_base_pct)} del lordo (${tx.taxes_included ? "scorporata" : "aggiunta"}) - Green Tax ${tx.green_tax_usd}$ + ${tx.green_council_usd}$ - 1 USD = ${v.usd_eur} EUR`,
    `ADR storico: ${["alta", "media", "bassa", "agosto"].map((b) => `${b} ${v.seasonal_adr?.[b] ? m(v.seasonal_adr[b]) : "n.d."}`).join(" / ")} - mesi storici validi: ${(v.history_months || []).join(", ") || "nessuno"}`,
  ].forEach((s) => { doc.text(ascii(s), M, y); y += 4.5; });
  if ((v.warnings || []).length) {
    y += 2; doc.setFont("helvetica", "bold"); doc.text("Controlli di plausibilita", M, y); y += 4.5; doc.setFont("helvetica", "normal");
    v.warnings.forEach((w) => { if (y < 200) { doc.text(ascii(`- ${w.text}`), M, y); y += 4.5; } });
  }
  doc.save(`Previsionale_${d.year}.pdf`);
}
